import React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AppProps as SingleSpaAppProps } from 'single-spa'
import { ApolloProvider as BFFProvider } from '@apollo/client'
import { ApolloClientBff } from './modules/apolloClients/ApolloClientBff'
import { ThemeProvider } from '@dasa-health/alma-react'
import { BrowserRouter } from 'react-router-dom'
import Routes from './router'
import { createGlobalStyle } from 'styled-components'

export type AppProps = SingleSpaAppProps & {
    paginasDeslogadasProps?: {
        basename: string
    }
}

const ToastGlobalStyle = createGlobalStyle`
    .Toastify__toast-container {
        width: fit-content !important;
        left: 50%;
        transform: translateX(-50%);
        bottom: 16px !important;
    }

    .Toastify__toast-theme--dark {
        border-radius: 8px;
    }
`

const App = ({ paginasDeslogadasProps }: AppProps): JSX.Element => (
    <BrowserRouter basename={paginasDeslogadasProps?.basename ?? ''}>
        <BFFProvider client={ApolloClientBff}>
            <ThemeProvider>
                <ToastGlobalStyle />
                <ToastContainer limit={1} position="bottom-center" theme="dark" />
                <Routes />
            </ThemeProvider>
        </BFFProvider>
    </BrowserRouter>
)
export default App
